import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { BulkUploadService } from '@app/feature/admin/report/upload/bulkupload.service';
import { HttpErrorResponse } from '@angular/common/http';
import { timer } from 'rxjs';

@Component({
  selector: 'app-bulkupload',
  templateUrl: './bulkupload.component.html',
  styleUrls: ['./bulkupload.component.scss']
})
export class BulkUploadComponent implements OnInit {

  form: FormGroup;

  uploadInfo: { errors?: string[]; finished: boolean; processing: boolean; progress?: number; uploadId?: string } = { finished: false, processing: false };

  error: string;

  constructor(private readonly formBuilder: FormBuilder,
              private readonly uploadService: BulkUploadService) {
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      uploadFile: ['']
    });
  }

  onFileChange(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.form.get('uploadFile').setValue(file);
    }
  }

  onSubmit() {
    this.error = null;

    const formData = new FormData();
    formData.append('uploadedFile', this.form.get('uploadFile').value);

    this.uploadService.upload(formData).subscribe(
      (response) => {
        if (response) {
          this.uploadInfo = response;
          if (response.uploadId) {
            const trigger = timer(1500);
            trigger.subscribe(__ => this.checkStatus(response.uploadId));
          }
        }
      },
      (error) => {
        if (error instanceof HttpErrorResponse) {
          this.uploadInfo = { finished: false, processing: false };
          if (400 === error.status) {
            this.error = 'Please, upload correct CSV file. Files of other types are not accepted.';
          } else if (413 === error.status) {
            if (error.error && error.error.maxFileSize) {
              this.error = 'File provided by you is too large, max. allowed size is ' + error.error.maxFileSize;
            } else {
              this.error = 'File provided by you is too large.';
            }
          } else {
            throw error;
          }

        }
      }
    );
  }

  checkStatus(uploadId: string) {
    this.uploadService.checkStatus(uploadId).subscribe(
      (response) => {
        this.uploadInfo = response;
        if (response.uploadId) {
          const trigger = timer(1500);
          trigger.subscribe(__ => this.checkStatus(response.uploadId));
        }
      }
    );
  }

}
